import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tires',
    templateUrl: './tires.component.html',
    styleUrls: ['./tires.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiresComponent {
  images = ['../../assets/images/bridgestone_tyres.svg', '../../assets/images/firestone_tyres.svg', '../../assets/images/nokian_tyres.jpg', '../../assets/images/michelin_tyres.jpg','../../assets/images/hankook_tyres.png', '../../assets/images/continental_tyres.jpg', '../../assets/images/falken_tyres.svg'];
  showNavigationArrows = true;
  showNavigationIndicators = true;
  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;
}

